import Aos from "aos";
import 'aos/dist/aos.css';
import { useEffect } from "react";
import xr_games from "../assets/videos/xr_games.mp4";
import './Common.css';
import './xr.css';


const XrService=()=>{
    useEffect(() => {
        Aos.init({ duration: 1000, offset: 250 });
    });
    return(
        <div id="xr-game" className="container pt-5">
            <div className="row xr-video-container d-flex justify-content-center align-items-center">
                <div className="col-12">
                    <video className="rounded-5 w-100 h-100" data-aos="zoom-in" autoPlay playsInline muted loop style={{objectFit:"cover"}}>
                        <source type="video/mp4; codecs=&quot;avc1.4D401E, mp4a.40.2&quot;" src={xr_games}></source>
                    </video>
                </div>
                
                <div className="row xr-text-container" data-aos="fade-right">
                    <div className="col-12 text-white">
                        <h1  className="fw-bolder fs-1 ">XR Games</h1>
                        <p className="fs-5 lead fw-bold">
                            We specialize in creating immersive XR (Extended Reality) games that blend the power of AR (Augmented Reality), VR (Virtual Reality), and MR (Mixed Reality) to deliver unforgettable gaming experiences. 
                            Our XR games transport players into dynamic virtual worlds, combining real and digital environments to engage players in unique and interactive adventures. 
                        </p>
                        <p className="fs-5 lead fw-bold ">
                            With cutting-edge technology, we craft games that not only entertain but also inspire creativity, critical thinking, and problem-solving. 
                            Whether for entertainment, education, or brand engagement, our XR games provide an innovative way to captivate and connect with audiences. 
                            Let’s take your gaming experience to the next level with our creative XR solutions!
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default XrService;